import React from 'react';
import variables from '../styles/variables.module.scss';

export enum Device {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

const useDevice = () => {
  const [device, setDevice] = React.useState<Device>();

  React.useEffect(() => {
    const update = () => {
      if (window.matchMedia(`(min-width: ${variables.screenMd})`).matches) {
        setDevice(Device.DESKTOP);
      } else {
        setDevice(Device.MOBILE);
      }
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return device;
};

export default useDevice;
